import * as React from "react";
import { UitkLink, UitkLinkAlign, UitkLinkTypeSize } from "uitk-react-link";
import { UitkIcon } from "uitk-react-icons";
import { locKeys } from "./l10n";
import { LocalizedText } from "bernie-l10n";

export const AirlineAgeRules = ({
  isFlightAdded,
  isChildUnderTwoPresent,
}: {
  isFlightAdded?: boolean;
  isChildUnderTwoPresent: boolean;
}) => {
  if (!isChildUnderTwoPresent || !isFlightAdded) {
    return null;
  }

  return (
    <>
      <UitkLink iconPos={UitkLinkAlign.RIGHT} type={UitkLinkTypeSize.SMALL} className="airlineAgeRules">
        <a href="/p/info-main/h_fw_default?rhtx=HTX_FLTSRCH_RT#travs" id="airline-age-rules" target="_blank">
          <LocalizedText message={locKeys.airlineAgeRules} />
          <UitkIcon id="airline-age-rules-opens-in-new" name="open_in_new" title="Opens in a new window" />
        </a>
      </UitkLink>
    </>
  );
};
